function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  x: 0.875,
  width: 17.833,
  height: 17.833,
  rx: 2.675,
  fill: "#000"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.792 4.017c-2.009 0-3.916-.179-4.645 1.69-.3.772-.257 1.774-.257 3.209 0 1.259-.04 2.442.257 3.208.727 1.87 2.65 1.69 4.644 1.69 1.923 0 3.907.2 4.644-1.69.302-.78.257-1.767.257-3.208 0-1.914.106-3.15-.823-4.077-.94-.94-2.212-.822-4.08-.822h.003zm-.44.883c4.19-.007 4.724-.472 4.43 5.994-.105 2.287-1.847 2.036-3.99 2.036-3.905 0-4.017-.112-4.017-4.016 0-3.95.31-4.012 3.578-4.015zm3.057.813a.588.588 0 100 1.176.588.588 0 000-1.176zM9.792 6.4a2.517 2.517 0 10-.001 5.033A2.517 2.517 0 009.792 6.4zm0 .883c2.16 0 2.163 3.266 0 3.266-2.16 0-2.163-3.266 0-3.266z",
  fill: "#fff"
});

function SvgInstagramBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default SvgInstagramBlack;